import { SelectRole } from "@components/role/select-role";
import { SelectRoleSubjectProps } from "@components/role/select-role-utils";
import { FaroCoreApiConst, FaroCoreApiTypes } from "@stellar/core-api-client";

/**
 *  Renders a dropdown to select project role
 *  TODO: Refactor this component to handle only TableCell fields, as it is no longer used for non-TableCell fields
 *  https://faro01.atlassian.net/browse/ST-2993.
 */
export function SelectProjectRole<
  T extends FaroCoreApiTypes.AssignmentRoleBySubjectType["project"],
>({
  selectedRole,
  onChange,
  variant,
  disabledRoles = [],
}: SelectRoleSubjectProps<T>): JSX.Element {
  function onSelectRoleChange(role: FaroCoreApiTypes.ProjectRole): void {
    // TODO: Type assertion will be fixed in https://faro01.atlassian.net/browse/ST-1902
    onChange(role as T);
  }
  return (
    <SelectRole
      label="Project role"
      roles={FaroCoreApiConst.allProjectRoles}
      disabledRoles={["RESOURCE_OWNER" as FaroCoreApiTypes.ProjectRole].concat(
        disabledRoles
      )}
      variant={variant}
      selectedRole={selectedRole}
      onChange={onSelectRoleChange}
      link="projectRolesHelp"
    />
  );
}
